import {Component, ElementRef, forwardRef, Host, Injector, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Select} from '@wba/commons/modules/wba-ui.module/components/formfields/select/select';
import {ValueAccessorAbstract} from '@wba-ui-module/components/formfields/commons/value-accessor.abstract';
import {EventUtils} from '@wba/utils/event.utils';

@Component({
    selector: 'wba-input-select',
    templateUrl: './select.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true
        }],
    standalone: false
})
export class SelectComponent extends ValueAccessorAbstract implements ControlValueAccessor, OnInit {
  @Input() id: string;
  @Input() name: string;
  @Input() label: string;
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() ariaLabel: string;
  @Input() items: Select[];
  @Input() hinweis: { target: string, modal: string };

  constructor(@Optional() @Host() @SkipSelf() private readonly controlContainer: ControlContainer,
              private readonly eventUtils: EventUtils,
              private readonly elementRef: ElementRef,
              protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
      } else {
        throw new Error('Missing FormControlName directive from host element of the component');
      }
    } else {
      throw new Error('Can\'t find parent FormGroup directive');
    }
  }

  // Set touched on blur
  onBlur() {
    this.onTouchedCallback();
    this.eventUtils.focusOut$.next(this.elementRef);
  }

  onChange(event: Event) {
    this.control.setValue((event.target as HTMLInputElement).value)
  }
}
